var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "signup-button", on: { click: _vm.onGoogleSignUp } },
    [
      _c("rt-picture", {
        staticClass: "provider-icon",
        attrs: { src: _vm.providerIcon, autosize: false },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "signup-button__text" }, [
        _c("span", [
          _vm._v(
            "Sign up with " +
              _vm._s(
                _vm.provider.charAt(0).toUpperCase() + _vm.provider.slice(1)
              )
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }